var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter"},[_c('ul',{staticClass:"filter--slider",style:(`--current: ${_vm.current};`)},_vm._l((_vm.filterValues),function(val,index){return _c('FilterValueCard',{key:val.value,attrs:{"filter":val,"selected":_vm.filterValue === val.value,"index":index},on:{"selected":_vm.onSelected}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }